import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=295e8d70&scoped=true&"
import script from "@/views/Subjects/Templates.ts?vue&type=script&lang=ts&"
export * from "@/views/Subjects/Templates.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Subjects/templates.scss?vue&type=style&index=0&id=295e8d70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295e8d70",
  null
  
)

export default component.exports